import { createSlice } from '@reduxjs/toolkit';
import {fetchUserType} from '../SignupApi/SignupApi';

const fetchUserTypeSlice = createSlice({
  name: 'fetchUserType',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchUserType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserType.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default fetchUserTypeSlice.reducer;
